export class AccountAccessEntry {
  accountCode: string;
  isExpired: boolean;
}
